import React from 'react';
import { Tree } from 'antd';
import styles from './GroupTree.module.css';

const GroupTree = ({ treeData, onSelect, onDetailClick, onAddGroup }) => {

  const formatTreeData = (nodes, depth = 1) =>
    nodes.map((node) => {
      const isUnassigned = node.groupId === 0 || node.title === '미지정'; // ← 미지정 그룹 판별

      return {
        ...node,
        title: (
          <div className={styles.groupRow}>
            <span className={styles.groupTitle}>
              {node.title}
            </span>
            <span className={styles.groupActions}>
              {/* //미지정이 아니고 1뎁스일 때만 + 버튼
              {depth === 1 && !isUnassigned && (
                <button
                  onClick={e => {
                    e.stopPropagation();
                    onAddGroup && onAddGroup(node);
                  }}
                  className={styles.addButton}
                  title="그룹 추가"
                >
                  +
                </button>
              )} */}
              {/* 미지정이 아닐 때만 상세 버튼 */}
              {!isUnassigned && (
                <span
                  onClick={e => {
                    e.stopPropagation();
                    onDetailClick && onDetailClick(node);
                  }}
                  className={styles.detailButton}
                  title="상세"
                >
                  🔍
                </span>
              )}
            </span>
          </div>
        ),
        children: node.children ? formatTreeData(node.children, depth + 1) : [],
      };
    });
  
  return (
    <Tree
      // showLine
      defaultExpandAll
      onSelect={onSelect}
      switcherIcon={null}
      treeData={formatTreeData(treeData)}
    />
  );
};

export default GroupTree;